import React from 'react';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Button } from '@material-ui/core';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import {
  baseStyles,
  menuItemStyles,
  menuListStyles,
  iconButtonStyles
} from './styles';

const DropdownIconButton = ({ list, click, children }) => {
  const baseClasses = baseStyles();
  const menuItemClasses = menuItemStyles();
  const menuListClasses = menuListStyles();
  const iconButtonClasses = iconButtonStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const onOpenHandler = event => {
    setAnchorEl(event.currentTarget);
  };

  const onCloseHandler = () => {
    setAnchorEl(null);
  };

  const onClickHandler = item => {
    click(item);
  };

  return (
    <div className={baseClasses.wrapper}>
      <Button classes={iconButtonClasses} onClick={onOpenHandler}>
        <AddCircleOutlineIcon className={baseClasses.circleIcon} />
        <span className={baseClasses.labelText}>{children}</span>
      </Button>
      <Menu
        id="simple-menu"
        classes={menuListClasses}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={onCloseHandler}
      >
        {list.map((item, index) => (
          <MenuItem
            classes={menuItemClasses}
            key={index}
            onClick={() => onClickHandler(item)}
          >
            {item}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default DropdownIconButton;
